// extracted by mini-css-extract-plugin
export default {"melodyVideo":"bN-z","isFullWidth":"cN-z","landingPageVideo":"dN-z","play":"eN-z","iframeVideo":"fN-z","playHidden":"gN-z","fullwidth":"hN-z"};